// extracted by mini-css-extract-plugin
export default {"header":"UserPage_header__ghNRG","dots_icon":"UserPage_dots_icon__RuPe+","tooltip_modal":"UserPage_tooltip_modal__fDkYv"};